import React from "react";

type breakpoints = "mobile" | "tablet" | "desktop";

type useBreakpointsHook = () => { currentBreakpoint: "mobile" | "tablet" | "desktop"; width: number };

function isBreakpointKey(toCheck: unknown): toCheck is breakpoints {
  return (
    typeof toCheck === "string" && (toCheck === "mobile" || toCheck === "tablet" || toCheck === "desktop")
  );
}

const useBreakpoints: useBreakpointsHook = () => {
  const breakpoints = { mobile: 0, tablet: 768, desktop: 1024 };
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const BreakpointValue = Object.entries(breakpoints)
    .reverse()
    .find(([key, value]) => width > value);

  const currentBreakpoint = BreakpointValue?.[0];

  return { width, currentBreakpoint: isBreakpointKey(currentBreakpoint) ? currentBreakpoint : "desktop" };
};

export default useBreakpoints;
